/**
 * Creates a box around the element (assumed to be the camera's PoV) which can be used for fade-to-black.
 */

const FADE_DURATION_MS = 750;

AFRAME.registerComponent("fader", {
  schema: {
    direction: { type: "string", default: "none" } // "in", "out", or "none"
  },

  init() {
    const mesh = new THREE.Mesh(
      new THREE.BoxGeometry(),
      new THREE.MeshBasicMaterial({ color: 0x0, side: THREE.BackSide, opacity: 0, transparent: true, fog: false })
    );
    mesh.scale.x = mesh.scale.y = 1;
    mesh.scale.z = 0.15;
    mesh.matrixNeedsUpdate = true;
    this.el.object3DMap.camera.add(mesh);
    this.mesh = mesh;
  },

  fadeOut() {
    return this.beginTransition("out");
  },

  fadeIn() {
    return this.beginTransition("in");
  },

  beginTransition(direction) {
    if (this._resolveFinish && this.data.direction === direction) {
      return this._transitionPromise;
    }

    // Navigation can reverse before the previous fade finishes. Release its
    // waiter and continue from the current opacity instead of rejecting the
    // latest reveal and leaving the camera permanently covered.
    if (this._resolveFinish) {
      this._resolveFinish(false);
      this._resolveFinish = null;
    }

    if (this.mesh.material.opacity === (direction === "in" ? 0 : 1)) {
      this.el.setAttribute("fader", { direction: "none" });
      this._transitionPromise = null;
      return Promise.resolve(true);
    }
    this.el.setAttribute("fader", { direction });

    this._transitionPromise = new Promise(res => {
      this._resolveFinish = res;
    });
    return this._transitionPromise;
  },

  tick(t, dt) {
    const mat = this.mesh.material;
    this.mesh.visible = this.data.direction === "out" || mat.opacity !== 0;
    if (!this.mesh.visible) return;

    if (this.data.direction === "in") {
      mat.opacity = Math.max(0, mat.opacity - (1.0 / FADE_DURATION_MS) * Math.min(dt, 50));
    } else if (this.data.direction === "out") {
      mat.opacity = Math.min(1, mat.opacity + (1.0 / FADE_DURATION_MS) * Math.min(dt, 50));
    }

    if (mat.opacity === 0 || mat.opacity === 1) {
      if (this.data.direction !== "none") {
        if (this._resolveFinish) {
          this._resolveFinish(true);
          this._resolveFinish = null;
          this._transitionPromise = null;
        }
      }

      this.el.setAttribute("fader", { direction: "none" });
    }
  }
});
